<app-processing [visible]="!pageVars.isReady"></app-processing>

<div class="flex justify-content-center">
  <p-card>
    <ng-template pTemplate="header">
      <p-breadcrumb [model]="pageVars.breadcrumbItems">
        <ng-template let-item let-last="last" let-first="first" pTemplate="item">
          <ng-container *ngIf="!first">
            <a *ngIf="item.routerLink" [routerLink]="item.routerLink">{{ item.label }}</a>
            <div *ngIf="!item.routerLink" class="breadcrumb-current-item">
              {{ item.label }}
            </div>
          </ng-container>
        </ng-template>
      </p-breadcrumb>
    </ng-template>
    <p-table [value]="data" dataKey="id" editMode="row" class="table-sm" [tableStyle]="{ 'min-width': '50rem', 'width': '50vw' }">
      <ng-template #header>
        <tr>
          <th>Name</th>
          <th>Active</th>
          <th>Last Action</th>
          <th>
            <div class="flex justify-content-center">
              <p-button
                class="mr-3 mt-3"
                label="New"
                [raised]="true"
                icon="fa fa-plus"
                size="small"
                (click)="gridNewRow()"
                [disabled]="pageVars.isEditing"
                data-testid="newItem"></p-button>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-project let-editing="editing" let-ri="rowIndex">
        <tr [pEditableRow]="project">
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="project.name" [style]="{ width: '100%' }" attr.data-testid="itemName{{ project.id }}" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ project.name }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-toggleswitch [(ngModel)]="project.isActive" attr.data-testid="toggleEdit{{ project.id }}" />
              </ng-template>
              <ng-template pTemplate="output">
                <p-toggleswitch [(ngModel)]="project.isActive" (change)="toggleStatus(project)" attr.data-testid="toggle{{ project.id }}" />
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <app-audit-info [value]="project" [direction]="'horizontal'"></app-audit-info>
              </ng-template>
              <ng-template pTemplate="output">
                <app-audit-info [value]="project" [direction]="'vertical'"></app-audit-info>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <div class="flex items-center justify-content-center gap-2">
              <button
                *ngIf="!editing"
                pButton
                pRipple
                type="button"
                pInitEditableRow
                icon="fa fa-pencil"
                (click)="gridRowEditInit(project)"
                text
                rounded
                severity="secondary"
                [outlined]="true"
                [disabled]="pageVars.isEditing"
                attr.data-testid="itemEdit{{ project.id }}"></button>
              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pSaveEditableRow
                icon="fa fa-check"
                (click)="gridRowEditSave(project, ri)"
                text
                rounded
                severity="success"
                size="large"
                [outlined]="true"
                attr.data-testid="itemSave{{ project.id }}"></button>
              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pCancelEditableRow
                icon="fa fa-times"
                (click)="gridRowEditCancel(project, ri)"
                text
                rounded
                severity="danger"
                size="large"
                [outlined]="true"
                attr.data-testid="itemCancel{{ project.id }}"></button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>

<p-dialog
  header="New Project"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="dialogVars.visible"
  [style]="{ width: '25rem' }"
  appendTo="body">
  <div class="mb-3">
    <p-floatlabel class="mt-1" variant="on">
      <label for="name">Name</label>
      <input pInputText id="name" class="w-full" autocomplete="off" [(ngModel)]="dialogVars.data.name" data-testid="newItemName" />
    </p-floatlabel>
  </div>

  <ng-template #footer>
    <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
      <p-button
        label="Cancel"
        icon="fa fa-times"
        severity="danger"
        size="small"
        [raised]="true"
        (click)="createDlgCancel()"
        data-testid="newItemCancel" />
      <p-button
        label="Save"
        icon="fa fa-check"
        severity="success"
        size="small"
        [raised]="true"
        (click)="createDlgSave()"
        [disabled]="!dialogIsValid()"
        data-testid="newItemSave" />
    </div>
  </ng-template>
</p-dialog>

<app-unsaved-changes-dialog [(visible)]="pageVars.showUnsavedChangesDialog" (decision)="onDialogConfirm($event)"> </app-unsaved-changes-dialog>
